import { render } from "./AccountTripHistoryPage.vue?vue&type=template&id=3a6574a1&scoped=true"
import script from "./AccountTripHistoryPage.vue?vue&type=script&lang=ts"
export * from "./AccountTripHistoryPage.vue?vue&type=script&lang=ts"

import "./AccountTripHistoryPage.vue?vue&type=style&index=0&id=3a6574a1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3a6574a1"

export default script